module.exports = __webpack_public_path__ + "b843a91b925cd0943d03ea3059c071e7.png";